import ModalFilters from '../components/ListFilter/ModalFilters';
import ModalApiError from '../components/ModalApiError';
import TableModalFilters from '../components/table/filters/TableModalFilters';
import ModalConfirm from '../components/ModalConfirm';

export default {
  'filters-modal': ModalFilters,
  'table-filters-modal': TableModalFilters,
  'api-error-modal': ModalApiError,
  'modal-confirm': ModalConfirm
};
